import { LitSquadInventoryEntry } from '@/lib/api';
import { Skeleton } from '@/components/ui/skeleton';

import { InventoryItemCard } from './InventoryItemCard';

interface InventoryGridProps {
  items: LitSquadInventoryEntry[];
  loading: boolean;
  onTransfer?: (item: LitSquadInventoryEntry) => void;
  onDelete?: (item: LitSquadInventoryEntry) => void;
  onClick?: (item: LitSquadInventoryEntry) => void;
}

export function InventoryGrid({
  items,
  loading,
  onTransfer,
  onDelete,
  onClick,
}: InventoryGridProps) {
  if (loading && items.length === 0) {
    return (
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
        {Array.from({ length: 8 }).map((_, i) => (
          <div key={i} className="space-y-2">
            <Skeleton className="aspect-square w-full rounded-lg" />
            <Skeleton className="h-4 w-3/4" />
            <Skeleton className="h-3 w-1/2" />
          </div>
        ))}
      </div>
    );
  }

  if (items.length === 0) {
    return (
      <div className="text-center py-12 text-muted-foreground">
        <p>No LitSquad NFTs found.</p>
        <p className="text-xs mt-2">
          Import your legacy LitSquad collection from the DFE Inventory Transition arche.
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
      {items.map((item) => (
        <InventoryItemCard
          key={item.itemId || `${item.itemDefId}-${item.instanceNumber}`}
          item={item}
          onTransfer={onTransfer}
          onDelete={onDelete}
          onClick={onClick}
        />
      ))}
    </div>
  );
}
